import styled from 'styled-components/macro';

export const FlexText = styled.div<{
  color?: string;
  fontStyle?: string;
  fontWeight?: string;
  width?: string;
  height?: string;
  textAlign?: string;
  minWidth?: string;
  children?: React.ReactNode;
}>`
  color: ${(p) =>
    p.color === 'accent'
      ? p.theme.palette.accentPrimary
      : p.color === 'accentSecondary'
      ? p.theme.palette.accentSecondary
      : p.color === 'primary'
      ? p.theme.palette.textPrimary
      : p.color && p.color.includes('#')
      ? p.color
      : p.theme.palette.textSecondary};
  font-style: ${(p) => p.fontStyle};
  font-weight: ${(p) => p.fontWeight};
  width: ${(p) => p.width};
  height: ${(p) => p.height};
  text-align: ${(p) => p.textAlign};
  min-width: ${(p) => p.minWidth};
`;
FlexText.defaultProps = {
  color: 'primary',
  fontStyle: 'normal',
  fontWeight: 'normal',
  width: 'max-content',
  height: 'max-content',
  textAlign: 'start',
};

export const TextRegular = styled(FlexText)<{ children?: React.ReactNode }>``;

export const TextTitle = styled(FlexText)<{ children?: React.ReactNode }>`
  font-size: ${(p) => p.theme.sizes.large};
  font-weight: ${(p) => p.theme.weights.heavy};
`;
TextTitle.defaultProps = {
  color: 'primary',
  fontStyle: 'normal',
  fontWeight: 'bold',
};

export const TextBold = styled(FlexText)<{ children?: React.ReactNode }>`
  font-weight: bold;
`;

export const TextRegularBold = styled(FlexText)<{ children?: React.ReactNode }>`
  font-weight: ${(p) => p.theme.weights.heavy};
`;

export const TextRegularItalics = styled(FlexText)<{
  children?: React.ReactNode;
}>`
  font-style: italic;
`;

export const TextSmall = styled(FlexText)<{ children?: React.ReactNode }>`
  font-size: ${(p) => p.theme.sizes.small};
`;

export const TextSmallBold = styled(TextSmall)`
  font-weight: ${(p) => p.theme.weights.heavy};
`;

export const TextSmallItalics = styled(TextSmall)`
  font-style: italic;
`;

export const TextTiny = styled(FlexText)`
  font-size: 11px;
`;

export const TextSpace = styled.div<{ width?: number }>`
  color: ${(p) => p.theme.palette.textSecondary};
  font-size: ${(p) => p.theme.sizes.small};
  font-weight: ${(p) => p.theme.weights.light};
  width: ${(p) => (p.width ? p.width : 5)}px;
`;
